import Levante1 from '../../Media/Produk/Levante.webp'
import Levante2 from '../../Media/Produk/Levante.webp'



const Levanteimages =[
    Levante1,Levante2
]

export default Levanteimages;